<!-- Drag and drop container -->
<div class="upload-container p-[30px]" (dragover)="dragDropEnabled && onDragOver($event)"
    (drop)="dragDropEnabled && onDrop($event)" (dragenter)="dragDropEnabled && onDragEnter($event)"
    (dragleave)="dragDropEnabled && onDragLeave($event)" [class.hover]="isHovered" [class.invalid]="invalid">

    <!-- File upload icon and text -->
    <div class="flex flex-col items-center gap-[10px] max-w-[410px]">

        <!-- ng-content to project custom content when not using default template -->
        <ng-content *ngIf="!useDefaultTemplate"></ng-content>

        <!-- Default template -->
        <ng-container *ngIf="useDefaultTemplate">
            <mat-icon [svgIcon]="svgIcon" class="w-10 h-10 transition-colors cursor-pointer"
                (click)="fileUpload.click()"></mat-icon>
            <p class="text-center">
                <span class="text-base max-w-[410px] text-center">
                    <ng-container *ngIf="dragDropEnabled" i18n>Sleep of</ng-container>
                </span>
                <span class="text-base text-app-global-secondary hover:cursor-pointer hover:underline"
                    (click)="fileUpload.click()">
                    <ng-container *ngIf="!dragDropEnabled" i18n> Kies</ng-container>
                    <ng-container *ngIf="dragDropEnabled" i18n> kies</ng-container>
                    <ng-container i18n> een bestand</ng-container>
                </span>
                <span *ngIf="multiple" class="text-base" i18n>. Je kunt meerdere bestanden tegelijk uploaden.</span>
            </p>
            <p class="text-sm text-app-global-text-secondary text-center" *ngIf="showSubtext" i18n>
                PDF, DOCX of Markdown bestanden van maximaal 25 MB
            </p>
        </ng-container>
    </div>

    <!-- Hidden HTML input element handling file selection -->
    <input class="hidden" type="file" [multiple]="multiple" #fileUpload
        (change)="handleFilesSelected($any($event.target))" [accept]="allowedFileExtensions">
</div>